import type { Database } from '@/entities/database';
import request from '@/shared/api/request';

export const getDatabase = (uuid: string): Promise<{ database: Database }> =>
  request<{ database: Database }>({
    url: `/databases/${uuid}/`,
  });
